export function testimonialsSlider() {
    $(".testimonials-slider").slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        infinite: false,
        fade: true,
        adaptiveHeight: true
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/testimonialsSlider.js